import { Flex, Text } from '@chakra-ui/react';
import { ColorPicker } from 'modules/Editor/components/ColorPicker';
import { memo } from 'react';
import { useSideMenuSetting } from 'widgets/sdk';

type MultipleChoicesSettingsColorPickerProps = {
  color: string;
  onChange: (color: string) => void;
  label: string;
  showNoColorChecker?: boolean;
};

export const MultipleChoicesSettingsColorPicker = memo(
  ({ label, color, onChange, showNoColorChecker = true }: MultipleChoicesSettingsColorPickerProps) => {
    const { setAllowScrolling } = useSideMenuSetting();
    return (
      <Flex align='center' w='full'>
        <Text mr='auto' fontSize='sm'>
          {label}
        </Text>
        <ColorPicker
          color={color}
          onChange={onChange}
          onClose={setAllowScrolling.on}
          onOpen={setAllowScrolling.off}
          placement='left'
          showNoColorChecker={showNoColorChecker}
          label={label}
        />
      </Flex>
    );
  },
);
MultipleChoicesSettingsColorPicker.displayName = 'MultipleChoicesSettingsColorPicker';
